module.exports = __webpack_public_path__ + "img/micas_urban_004.167a08e3.jpg";